import React, { useEffect, useState } from "react";
import { Card, Col, Switch, Tooltip, Typography } from "antd";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import FeatureItem from "./FeatureItem";

const { Text } = Typography;

function isFeatureDisabled(disabledFeatures, action) {
  if (!action) {
    action = "show";
  }
  if (disabledFeatures) {
    const disabledFeature = disabledFeatures.find(
      (item) => item.action === action && item.disabled
    );
    if (disabledFeature) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const FeatureGroup = (props) => {
  const [showItem, setShowItem] = useState(undefined);
  const [showEnabled, setShowEnabled] = useState(false);

  useEffect(() => {
    setShowItem(props.items.find((item) => item.action === "show"));
  }, [props.items]);

  useEffect(() => {
    if (isFeatureDisabled(props.disabledItems, "show")) {
      setShowEnabled(false);
    } else {
      setShowEnabled(true);
    }
  }, [props.disabledItems]);

  return (
    <Col xs={24} sm={12} md={12} lg={8} xl={8}>
      <Card
        title={
          showItem?.label
            ? showItem.label
            : capitalizeFirstLetter(props.group)
        }
        extra={
          showItem && (
            <div>
              {showItem.module && (
                <Tooltip title={`Modulo: ${showItem.module.name}`}>
                  {showItem.included ? (
                    <span style={{ marginRight: 8 }}>
                      <CheckCircleOutlined style={{ color: "#52c41a" }} />
                    </span>
                  ) : (
                    <span style={{ marginRight: 8 }}>
                      <InfoCircleOutlined style={{ color: "#1890ff" }} />
                    </span>
                  )}
                </Tooltip>
              )}
              <Switch
                checked={showEnabled}
                onChange={() => {
                  props.handleClick({
                    product: props.product,
                    key: `${props.group}.${showItem.action}`,
                    disabled: showEnabled,
                  });
                }}
              />
            </div>
          )
        }
        style={{ height: "100%" }}
      >
        {showItem?.description && (
          <Text
            type="secondary"
            style={{ fontSize: 12, display: "block", marginBottom: 12 }}
          >
            {showItem.description}
          </Text>
        )}
        {showEnabled &&
          props.items
            .filter((item) => item.action !== "show")
            .sort((a, b) =>
              a.label
                ? a.label.localeCompare(b.label ? b.label : b.action)
                : a.action.localeCompare(b.label ? b.label : b.action)
            )
            .map((item) => {
              return (
                <FeatureItem
                  key={item.action}
                  item={item}
                  product={props.product}
                  group={props.group}
                  disabled={isFeatureDisabled(props.disabledItems, item.action)}
                  handleClick={props.handleClick}
                  showItem={showItem}
                />
              );
            })}
      </Card>
    </Col>
  );
};

export default FeatureGroup;
